import React from 'react'
import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";

import Header from '../Header'
import Profile from '../../components/Profile'
import Manage from '../../components/Manage'
import Home from '../../components/Home'
import About from '../../components/About'
import Feed from '../../components/Feed'
import Connect from '../../components/Connect'
import LoadingScreen from '../../components/LoadingScreen'

import ProtectedRoute from '../ProtectedRoute';

class App extends React.Component {
  constructor() {
    super()
    this.state = {
      showLoadingScreen: true
    }
  }
  componentDidMount(){
    const self = this
    setTimeout(function(){
      self.setState({showLoadingScreen: false})
    }, 4000)
  }
  render() {
    return (
      <Router>
        {this.state.showLoadingScreen ? <LoadingScreen /> : null }
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Header />
            <div id='content' style={{ flex: 1 }}>
              <Route exact path="/">
                <Home store={this.props.store} />
              </Route>
              <Route path="/about">
                <About />
              </Route>
              <Route path="/profile">
                <ProtectedRoute nextRoute="/profile">
                  <Profile />
                </ProtectedRoute>
              </Route>
              <Route path="/manage">
                <ProtectedRoute nextRoute="/manage">
                  <Manage />
                </ProtectedRoute>
              </Route>
              <Route path="/feed">
                <Feed />
              </Route>
              <Route path="/reports">
                <Profile />
              </Route>
              <Route path="/connect">
                <Connect />
              </Route>
            </div>

          </div>
      </Router>
    )
  }
}

export default App

